export default __webpack_public_path__ + "static/media/team-photo-2011.ca531bc9.jpg";